import Box from '@mui/material/Box'
import { FormControl, InputLabel } from '@mui/material'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import useGetFilters from '../../../../hooks/useGetAllTags'
import { titleCase } from 'utils'
import { settings } from 'settings'

const Dropdowns = ({
  period,
  handlePeriodValue,
  chapter,
  handleChapterValue,
  selectedCourse,
  handleSelectedCourse,
}) => {
  const { courses, coursesWithChapters, chapters } = useGetFilters()

  const chaptersToMap =
    selectedCourse === 'all' ? chapters : coursesWithChapters[selectedCourse]

  return (
    <div className="flex justify-start gap-1">
      <Box className="min-w-[100px] sm:min-w-[120px] ">
        <FormControl
          className="text-over-primary-background capitalize focus:border-none"
          fullWidth
        >
          <InputLabel
            key="course-label"
            className="!text-primary"
            id="demo-simple-select-label"
          >
            {titleCase(settings.materie)}
          </InputLabel>
          <Select
            key="course-selector"
            sx={{
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: 'gray !important',
              },
              '& .MuiSelect-select': {
                color: 'rgb(var(--text-over-secondary-background)) !important',
              },
            }}
            MenuProps={{
              sx: {
                '& .MuiPaper-root': {
                  backgroundColor:
                    'rgb(var(--secondary-background)) !important',
                  border: '1px solid rgb(var(--brd-primary)) !important',
                  color:
                    'rgb(var(--text-over-secondary-background)) !important',
                },
                '& .MuiMenuItem-root': {
                  backgroundColor: 'rgb(var(--secondary-background))',
                  color: 'rgb(var(--over-secondary-background)) !important',
                  '&:hover': {
                    backgroundColor: 'rgb(var(--primary))',
                  },
                },
                '& .Mui-selected': {
                  backgroundColor: 'rgb(var(--primary)) !important',
                },
                '& .MuiOutlinedInput-input': {
                  color: 'white !important',
                },
              },
            }}
            className="h-9 !bg-secondary-background !text-over-primary-background"
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={selectedCourse}
            label="Materie"
            onChange={handleSelectedCourse}
          >
            <MenuItem value="all">Toate</MenuItem>
            {courses?.map(course => (
              <MenuItem
                key={`course-${course}`}
                className="text-over-primary-background capitalize"
                value={course}
              >
                {course}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      <Box className="min-w-[100px] sm:min-w-[120px]">
        <FormControl
          key="chapter-selector"
          className="text-over-primary-background capitalize focus:border-none"
          fullWidth
        >
          <InputLabel
            key="chapter-label"
            className="!text-primary"
            id="demo-simple-select-label"
          >
            Capitol
          </InputLabel>
          <Select
            sx={{
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: 'gray !important',
              },
              '& .MuiSelect-select': {
                color: 'rgb(var(--text-over-secondary-background)) !important',
              },
            }}
            key="chapter-selector"
            MenuProps={{
              sx: {
                '& .MuiPaper-root': {
                  backgroundColor:
                    'rgb(var(--secondary-background)) !important',
                  border: '1px solid rgb(var(--brd-primary)) !important',
                  color:
                    'rgb(var(--text-over-secondary-background)) !important',
                },
                '& .MuiMenuItem-root': {
                  backgroundColor: 'rgb(var(--secondary-background))',
                  color: 'rgb(var(--over-secondary-background)) !important',
                  '&:hover': {
                    backgroundColor: 'rgb(var(--primary))',
                  },
                },
                '& .Mui-selected': {
                  backgroundColor: 'rgb(var(--primary)) !important',
                },
              },
            }}
            className="h-9 !bg-secondary-background !text-over-primary-background"
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={chapter}
            label="Capitol"
            onChange={handleChapterValue}
          >
            <MenuItem value="all">Toate</MenuItem>
            {chaptersToMap?.map(chapter => (
              <MenuItem
                key={`chapter-${chapter.name}`}
                className="capitalize"
                value={chapter.name}
              >
                {chapter?.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      <Box className="min-w-[100px] sm:min-w-[120px] ">
        <FormControl
          className="text-over-primary-background capitalize focus:border-none"
          fullWidth
        >
          <InputLabel
            key="period-label"
            className="!text-primary"
            id="demo-simple-select-label"
          >
            Perioada
          </InputLabel>
          <Select
            key="period-selector"
            sx={{
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: 'gray !important',
              },
              '& .MuiSelect-select': {
                color: 'rgb(var(--text-over-secondary-background)) !important',
              },
            }}
            MenuProps={{
              sx: {
                '& .MuiPaper-root': {
                  backgroundColor:
                    'rgb(var(--secondary-background)) !important',
                  border: '1px solid rgb(var(--brd-primary)) !important',
                  color:
                    'rgb(var(--text-over-secondary-background)) !important',
                },
                '& .MuiMenuItem-root': {
                  backgroundColor: 'rgb(var(--secondary-background))',
                  color: 'rgb(var(--over-secondary-background)) !important',
                  '&:hover': {
                    backgroundColor: 'rgb(var(--primary))',
                  },
                },
                '& .Mui-selected': {
                  backgroundColor: 'rgb(var(--primary)) !important',
                },
              },
            }}
            className="h-9 !bg-secondary-background !text-over-primary-background"
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={period}
            label="Perioada"
            onChange={handlePeriodValue}
          >
            <MenuItem className="text-over-primary-background" value="weekly">
              Ultima Săptămână
            </MenuItem>
            <MenuItem className="text-over-primary-background" value="monthly">
              Ultimele luni
            </MenuItem>
          </Select>
        </FormControl>
      </Box>
    </div>
  )
}

export default Dropdowns
